/**
 * Format a given date string to a more readable format (Day, Month, Year).
 * @param {string | null | undefined} dateString 
 * @returns {string}
 */
export function formatDate(dateString) {
  if (!dateString) return 'N/A'; 

  const date = new Date(dateString);
  
  // Check for invalid date
  if (isNaN(date.getTime())) return 'N/A'; 

  return date.toLocaleDateString("en-GB", {
    day: "numeric",   
    month: "long",   
    year: "numeric",
  });
}
